import { useState } from "react";
import { PersonSegmentIcon } from "@shopify/polaris-icons";
import { Button } from "@shopify/polaris";
import { sendAutomatedMessage } from "../utilities/networkCalls";
import mixpanel from "mixpanel-browser";

const CalloutNudgeBanner = ({ onHomePage = false }: { onHomePage?: boolean }) => {
    const setupCalendlyMeet = () => {
        mixpanel.track(`Schedule meeting for later button clicked`, {
            CTA: "Or, Schedule for Later",
            screen: window.location.pathname.split("/").pop(),
        });
        window.open(
            "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1mRg4kAUX2ScUJLSPdxcTAXbfbfB3gJr65J8F_KDSwTVUcvkaPogilHTparHVV8HYPjb0TALin",
            "_blank",
        );
    };

    const [isLoading, setIsLoading] = useState(false);

    const handleStartInstantMeeting = async () => {
        setIsLoading(true);

        try {
            mixpanel.track("Start Instant Call Button Clicked", {
                CTA: "Start Instant Call",
                screen: window.location.pathname.split("/").pop(),
            });

            const message = "Hi, I'd like to get on an instant call with a specialist";
            await sendAutomatedMessage(message);
            window.userengage("event.instant_call");
        } catch (error) {
            console.error("Failed to initiate chat:", error);
            shopify.toast.show("Failed to start instant meet. Please try again later.", {
                isError: true,
                duration: 2000,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const isWithinLiveHours = () => {
        return false; // TODO: remove this when we have a way to send msg on mantle
        const now = new Date();

        // convert to IST (UTC + 5:30)
        const utcTime = now.getTime() + now.getTimezoneOffset() * 60000;
        const istTime = new Date(utcTime + 5.5 * 60 * 60000);

        const day = istTime.getDay();
        const hours = istTime.getHours();
        const minutes = istTime.getMinutes();

        if (day < 1 || day > 5) return false;

        const currMinutes = hours * 60 + minutes;
        const startMinutes = 10 * 60; // start from 10AM
        const endMinutes = 18 * 60 + 30; // ends at 6:30PM

        return currMinutes >= startMinutes && currMinutes <= endMinutes;
    };

    const showInstantCall = isWithinLiveHours();

    return window?.showCalloutNudge ? (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: onHomePage ? "10px" : "8px",
                backgroundColor: "#fff",
                borderRadius: onHomePage ? "6px" : "12px",
                padding: onHomePage ? "12px" : "16px",
                marginTop: onHomePage ? "0px" : "16px",
            }}
        >
            <h1
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    fontSize: "15px",
                    fontWeight: "600",
                }}
            >
                <PersonSegmentIcon width={20} height={20} fill="#303030" />
                <span style={{ fontSize: "14px" }}>Talk to an Expert Now</span>
            </h1>

            <p style={{ fontSize: "13px" }}>
                {showInstantCall ? (
                    <>
                        Have a question about setup or design? <br /> An e-commerce specialist is available for an
                        instant video call.
                    </>
                ) : (
                    <>
                        Have a question about setup or design? <br /> Schedule a call with our e-commerce specialist.
                    </>
                )}
            </p>

            {showInstantCall ? (
                <div style={{ display: "flex", gap: "16px", justifyContent: "flex-start" }}>
                    <Button variant="primary" onClick={handleStartInstantMeeting} loading={isLoading}>
                        Start Instant Call
                    </Button>
                    <Button variant="tertiary" onClick={setupCalendlyMeet}>
                        Or, Schedule for Later
                    </Button>
                </div>
            ) : (
                <Button variant="primary" onClick={setupCalendlyMeet}>
                    Schedule Call
                </Button>
            )}
        </div>
    ) : null;
};

export default CalloutNudgeBanner;
